import { render, staticRenderFns } from "./UploadValidation.vue?vue&type=template&id=35aa0c72&"
import script from "./UploadValidation.vue?vue&type=script&lang=js&"
export * from "./UploadValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports